import React, { useEffect, useReducer, createContext, Dispatch } from 'react';
import { KEY_ACCESS_TOKEN, KEY_REFRESH_TOKEN } from '../constant';
import { AuthAction, AuthState, AuthUser } from '../../interfaces/Contexts';
import { ReactChildren } from '../../interfaces/Common';
import storage from '../../storageService';
import { Logout } from '../../Utils/apiService';

export const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  search: null,
  isLoading: true, // Add loading state
};

const reducer = (state: AuthState, action: AuthAction): AuthState => {
  switch (action.type) {
    case 'LOGIN':
      const userPayload: any = action.payload || { user: null };
      


      console.log(userPayload.user,"sdfn sdfk ");
      
      // Extract actual token strings from nested structures
      const accessTokenString = userPayload.user?.accessToken?.token?.token || userPayload.user?.accessToken?.token || '';
      const refreshTokenString = userPayload.user?.refreshToken?.token?.token || userPayload.user?.refreshToken?.token || '';
      
      // Normalize the user object with proper token structure
      const normalizedUser = userPayload.user ? {
        ...userPayload.user,
        accessToken: {
          token: accessTokenString
        },
        refreshToken: {
          token: refreshTokenString
        }
      } : null;
      
      storage.set(KEY_REFRESH_TOKEN, refreshTokenString);
      console.log('userPayload.user?.accessToken?.token', KEY_ACCESS_TOKEN, accessTokenString);
      
      storage.set(KEY_ACCESS_TOKEN, accessTokenString);
      
      storage.set('user', JSON.stringify(normalizedUser));
      localStorage.setItem("user", JSON.stringify(normalizedUser));
      return {
        ...state,
        isAuthenticated: normalizedUser && normalizedUser !== null ? true : false,
        user: normalizedUser,
        isLoading: false,
      };
    case 'LOGOUT':
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      Logout({
        "contactId": user.applicantId,
        "portalLogout": true
      });
      storage.clear();
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        search: null,
        isLoading: false,
      };
    case 'SET_LOADING':
      return {
        ...state,
        isLoading: action.payload?.isLoading ?? false,
      };
    case 'RESTORE_AUTH':
      return {
        ...state,
        isAuthenticated: action.payload?.user ? true : false,
        user: action.payload?.user || null,
        isLoading: false,
      };
    default:
      return state;
  }
};

export const AuthContext = createContext<{
  state: AuthState;
  dispatch: Dispatch<AuthAction>;
}>({ state: initialState, dispatch: () => { } });

export const AuthContextProvider: React.FunctionComponent<ReactChildren> = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // Set loading state
        dispatch({ type: 'SET_LOADING', payload: { isLoading: true } });
        
        // Add a small delay to ensure storage is ready
        await new Promise(resolve => setTimeout(resolve, 100));
        
        const user = await storage.get('user');
        const accessToken = await storage.get(KEY_ACCESS_TOKEN);
        const refreshToken = await storage.get(KEY_REFRESH_TOKEN);
        
        if (user && accessToken && refreshToken) {
          try {
            const parsedUser: AuthUser = JSON.parse(user);
            
            // Validate that we have the required tokens
            if (parsedUser.accessToken?.token && parsedUser.refreshToken?.token) {
              dispatch({
                type: 'RESTORE_AUTH',
                payload: {
                  user: parsedUser,
                },
              });
            } else {
              // Invalid token structure, clear and logout
              dispatch({ type: 'LOGOUT' });
            }
          } catch (parseError) {
            console.error('Failed to parse user data', parseError);
            dispatch({ type: 'LOGOUT' });
          }
        } else {
          // No user data found, set as not authenticated
          dispatch({ type: 'RESTORE_AUTH', payload: { user: null } });
        }
      } catch (error) {
        console.error('Failed to fetch user data', error);
        dispatch({ type: 'RESTORE_AUTH', payload: { user: null } });
      }
    };

    fetchUserData();

    // // Listen for storage changes to update auth context when tokens are refreshed
    // const handleStorageChange = async () => {
    //   try {
    //     const user = await storage.get('user');
    //     if (user) {
    //       const parsedUser: AuthUser = JSON.parse(user);
    //       if (parsedUser.accessToken?.token && parsedUser.refreshToken?.token) {
    //         dispatch({
    //           type: 'RESTORE_AUTH',
    //           payload: {
    //             user: parsedUser,
    //           },
    //         });
    //       }
    //     }
    //   } catch (error) {
    //     console.warn('Failed to update auth context from storage change:', error);
    //   }
    // };

    // // Listen for custom token refresh events
    // const handleTokenRefresh = (event: CustomEvent) => {
    //   try {
    //     const { newUserData } = event.detail;
    //     if (newUserData) {
    //       dispatch({
    //         type: 'RESTORE_AUTH',
    //         payload: {
    //           user: newUserData,
    //         },
    //       });
    //     }
    //   } catch (error) {
    //     console.warn('Failed to update auth context from token refresh event:', error);
    //   }
    // };

    // // Add event listeners
    // window.addEventListener('storage', handleStorageChange);
    // window.addEventListener('tokenRefreshed', handleTokenRefresh as EventListener);
    
    // return () => {
    //   window.removeEventListener('storage', handleStorageChange);
    //   window.removeEventListener('tokenRefreshed', handleTokenRefresh as EventListener);
    // };
  }, [dispatch]);

  return (
    <AuthContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};
